<template>
    <rkm-overlay :show="loading">
        <rkm-form
            class="login-form"
            ref="RkmForm"
        >
            <h2>Criar nova senha</h2>

            <p class="subtitle">
                Por segurança, é necessário criar uma nova senha para acessar o sistema
            </p>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nova_senha"
                        name="Nova senha"
                        placeholder="Digite sua nova senha"
                        type="password"
                        v-model="model.nova_senha"
                        vid="nova_senha"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon icon="lock" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nova_senha_confirmation"
                        name="Confirmar nova senha"
                        placeholder="Confirme sua nova senha"
                        type="password"
                        v-model="model.nova_senha_confirmation"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon icon="check" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <div class="login-form-actions">
                        <rkm-row>
                            <rkm-col>
                                <rkm-button
                                    :disabled="loading"
                                    @click="handleTrocarSenha"
                                    block
                                    color="primary"
                                >
                                    Atualizar senha
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-link @click="handleLogout">
                                    <rkm-icon icon="sign-out-alt" class="me-1" /> Sair do sistema
                                </rkm-link>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-overlay>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('autenticacao-trocar-senha-form')
        },
        validations() {
            return {
                nova_senha: {
                    required: true,
                    min: 8,
                    max: 12,
                    senha: true,
                },
                nova_senha_confirmation: {
                    required: true,
                    min: 8,
                    max: 12,
                    confirmed: 'nova_senha',
                },
            }
        },
    },
    data: () => ({
        model: {
            nova_senha: null,
            nova_senha_confirmation: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'clearLocalStorage',
            'setLoading',
            'unsetLoading',
        ]),
        handleLogout() {
            this.repositories.autenticacao.logout()
                .then(() => this.$router.push({name: 'login'}))
                .catch(this.handleError)
        },
        handleTrocarSenha() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('autenticacao-trocar-senha-form')

                        this.repositories.perfil.update(this.model)
                            .then(() => {
                                this.showSuccessNotification(null, 'Senha alterada com sucesso.')
                                this.$router.push({name: 'login'})
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('autenticacao-trocar-senha-form'))
                    }
                })
        },
    },
    mixins: [error, notification],
}
</script>